<nav class="cv-object-navigation cv-object-navigation-component" id="{{navigationId}}">
	<ol class="breadcrumb">
		<li class="breadcrumb-item" *ngFor="
			let navigationElement of navigationElements;
			let navigationElementIndex = index">
			
			<button
				class="breadcrumb-item-path"
				(click)="selectNavigationElement(
					$event,
					navigationElement,
					navigationElementIndex
				)">
				<span class="item-value">{{ navigationElement.name }}</span>
			</button>
			<cv-dropdown-breadcrumb 
				[ngClass]="{ hidden: !navigationElement.dropdownItems.length }"
				[items]="navigationElement.dropdownItems" 
				[itemTextKey]="'name'" 
				[appendTo]="'#' + navigationId"
				(itemSelected)="dropdownItemSelected($event, navigationElementIndex)">
			</cv-dropdown-breadcrumb>
		</li>
	</ol>
</nav>